import React from 'react';
import dr_img from './../components/assets/images/dR IBRAHIMI IMAGE.png';
import dr_img2 from './../components/assets/images/Group 2.png';


const HomePage = () => (
    <div className="home-page">
    <div className="mt-2">
        <h3>Dr.Ebrahimi</h3>
        <img src={dr_img2} alt="about-bg" className="dr_image" />
        <p>
            Dr. Alireza Ebrahimi earned his Ph.D. in Computer Science from the Polytechnic University of New
            York. His graduate studies were at Courant Institute of Mathematical Sciences/NYU. Dr.
            Ebrahimi's teaching interests are Programming C/C++, Management Information Systems, Web
            Systems, E-Commerce, Operations Management, Artificial Intelligence and Building Expert Systems.
            Dr. Ebrahimi’s research includes Managers acquaintance with technology, Web site and System
            analysis, Programming Language, Self-Directed Design, System Design and Computer and Human
            Interaction

            Dr. Ebrahimi’s works have been published in various Journals and National and International
            conference proceedings such as The International Journal of Applied Management and Technology,
            Journal of Educational Technology Systems, Ubiquitous learning, International Journal of
            Learning, and Association for Computing Machinery/ Computer Science Education and IEEE Xplore.
            Dr. Ebrahimi served as co-editor of ACM SIGCSE Inroads Special edition (Human Computer Errors)
            in June 2007

            Dr. Ebrahimi published a two-volume book and several book Chapters. Dr. Ebrahimi invented: Web
            VPCL (with USPTO) and developed a criteria to evaluate web sites called 7x2 C's with seven (7)
            layers of application and development.

            Dr. Ebrahimi received two Chancellors’ awards for Excellence in Teaching in 1993 and in
            Scholarship and Creativity in 2006 from the State University of New York. Dr. Ebrahimi served as
            chair of Computer Information Science/Management Information Systems for three years. Dr.
            Ebrahimi has served as chair of faculty rights, responsibilities for three terms a. Dr. Ebrahimi
            served as Director/Chair of Teaching for Learning Center (TLC) at SUNY Old Westbury and founded
            and organized Annual faculty Conference for more than a decade.

            His research "Expressing Programming Algorithms with Poetic Language" was published in June 2014
            edition of ACM Inroads. Dr. Ebrahimi's system known as VPCL was published as a book chapter in
            Handbook of Research on Maximizing Cognitive Learning through Knowledge Visualization in 2015.
            His current work is creating awareness system for covid-19 presented and published IEEE/ISTAS20
            conference in 2020 and IEEE Computational Science & Computational Intelligence (CSCI) in 2021.

            Dr. Ebrahimi Self-directed design's work was presented in SUNY CIT 2022 and the research work in
            embedding programming in the curriculum was presented at the World Conference on Continuing
            Engineering Education (IACEE) in June 2022.

            Dr.Ebrahimi self direct learning and self design published in the year 2023.
        </p>

    </div>

</div>
);

export default HomePage;
